
import { __ } from '@wordpress/i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import snackbar from 'snackbar';
import { useEffect, useState } from 'react';
import System from '../content/system';
import Demo from '../content/demo';
import { applyFilters } from '@wordpress/hooks';
import Elements from '../content/elements';
import ThemeBuilder from '../content/theme-builder';
import UpgradePopup, { UpgradeProDashboard } from '../content/banner-pro';
import { subscribeNewsletter } from "../helper/axios";
import { Loader } from "react-feather";
import Pricing from '../content/pricing';
import DashboardSubmenu from '../content/home/dashboard-submenu';

const Content = () => {

    const { root, homeSlug, plugins } = window['JkitDashboardOption'];
    const [snackbarString, setSnackbar] = useState(false);

    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const query = new URLSearchParams(useLocation().search);
    const { pathname, search } = useLocation();
    const page = query.get('page');
    const path = query.get('path');
    const subPath = query.get('subpath');
    const param = `?page=${page}&path=demos`;
    const [showBanner, setShowBanner] = useState(false)


    useEffect(() => {
        if (snackbarString && !snackbarVisible) {
            setSnackbarVisible(true);
            snackbar.view = document.querySelector('#wpbody').appendChild(document.createElement('div'));
            snackbar.view.classList.add('snackbar');
            snackbar.duration = 5000;
            snackbar.gap = 250;
            snackbar.show(snackbarString);
            setTimeout(() => {
                setSnackbar(false);
            }, 200);
            setTimeout(() => {
                setSnackbarVisible(false);
            }, 5200);
        }
    }, [snackbarString, snackbarVisible]);

    const navigate = useNavigate();

    const goToLicensePage = () => {
        navigate({
            pathname: pathname,
            search: '?page=jkit&path=license'
        });
    };


    let routePage = '';

    const props = {
        setSnackbar,
        setShowBanner,
        goToLicensePage,
        DashboardSubmenu,
    };

    if (root === page) {
        switch (path) {
            case 'demos':
                routePage = <Demo {...props} />;
                break;
            case 'elements':
                routePage = <Elements {...props} />;
                break;
            case 'system-status':
                routePage = <System {...props} />;
                break;
            case 'theme-builder':
                routePage = <ThemeBuilder {...props} />;
                break;
            case 'upgrade-to-pro':
                routePage = <Pricing {...props}/>;
                break;
            case null:
            default:
                routePage = <Dashboard {...props} />;
                break;
        }
    }

    const paths = {
        path,
        subPath
    };

    routePage = applyFilters(
        'jkit.dashboard.route.content',
        routePage,
        paths,
        props
    );

    return <div className={`f-content ${path ? `f-content__${path}` : 'f-content__dashboard'}`}>
        {routePage}
        {showBanner && <UpgradePopup closeState={setShowBanner} goToLicensePage={goToLicensePage} />}
    </div>;
};



const Dashboard = (props) => {
    const {
        imgDir,
        homeUrl,
        themeVersion,
        ratingUrl,
        upgradeURL,
        forumUrl,
        documentationUrl
    } = window['JkitDashboardOption'];

    const [email, setEmail] = useState('');
    const [extraClass, setExtraClass] = useState('');
    const { setSnackbar } = props;

    const subscribe = () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (emailPattern.test(email)) {
            setExtraClass('loading');
            subscribeNewsletter(email, homeUrl)
                .then((result) => {
                    if (result.message) {
                        setSnackbar(result.message);
                    }
                    setExtraClass('');
                })
                .catch(() => {
                    setSnackbar('Email invalid');
                    setExtraClass('');
                });
        } else {
            setSnackbar('Email invalid');
        }
    };

    return <div className="profecient-dashboard-wrapper">
        <div className="profecient-dashboard-left">
            <DashboardSubmenu />

            <Pricing {...props} />
        </div>
    </div>;
};

export default Content;
